import { useTranslation } from "react-i18next";
import { LocaleLink } from "../Language/LocaleLink";

export const WhoIsItFor = () => {
  const { t } = useTranslation();

  // Icon chips alternate between the two brand colors (emerald + accessible
  // amber) instead of six unrelated hues, so the grid reads as one system.
  // Developers lead: they're the best-converting audience in Search Console,
  // and the hero mockup already speaks to them.
  const userTypes = [
    {
      icon: "bi-laptop",
      color: "primary",
      key: "developers",
      to: "/bookmarks-for-developers",
    },
    {
      icon: "bi-book",
      color: "warning",
      key: "researchers",
      to: "/bookmarks-for-researchers",
    },
    {
      icon: "bi-heart",
      color: "primary",
      key: "personal",
    },
    {
      icon: "bi-briefcase",
      color: "warning",
      key: "business",
    },
    {
      icon: "bi-brush",
      color: "primary",
      key: "creatives",
    },
    {
      icon: "bi-people",
      color: "warning",
      key: "teams",
    },
  ];

  return (
    <section id="who-is-it-for" className="section-padding bg-light mt-5">
      <div className="container">
        <div className="col-lg-5 col-sm-12">
          <h5 className="mb-3 text-primary fw-semibold">
            {t("home.whoIsItFor.badge")}
          </h5>
          <h2 className="display-6 fw-bold mb-3">{t("home.whoIsItFor.title")}</h2>
          <p className="lead mb-0">{t("home.whoIsItFor.description")}</p>
        </div>

        <div className="row g-4 mt-3">
          {userTypes.map((userType) => (
            <div key={userType.key} className="col-lg-4 col-md-6">
              <div className="card h-100 border-0 shadow-sm hover-lift">
                <div className="card-body p-4">
                  <div
                    className={`icon icon-lg bg-${userType.color} bg-opacity-10 rounded-3 mb-4`}
                  >
                    <i
                      className={`bi ${userType.icon} fs-3 text-${userType.color}`}
                    ></i>
                  </div>
                  <h3 className="h4 fw-bold mb-3">
                    {t(`home.whoIsItFor.${userType.key}.title`)}
                  </h3>
                  <p className="text-muted mb-4">
                    {t(`home.whoIsItFor.${userType.key}.description`)}
                  </p>
                  <ul className="list-unstyled text-muted">
                    {t(`home.whoIsItFor.${userType.key}.features`, {
                      returnObjects: true,
                    }).map((feature, index) => (
                      <li key={index} className="d-flex align-items-start mb-2">
                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                  {userType.to && (
                    <LocaleLink
                      to={userType.to}
                      className="btn btn-none text-primary p-0 d-inline-flex align-items-center gap-2"
                    >
                      {t("home.whoIsItFor.learnMore", "Learn more")}
                      <i className="bi bi-arrow-right"></i>
                    </LocaleLink>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
